/* global ol */

var angular = require('angular');

function MouseCursor(map, canEdit) {
  this.cursor = '';

  this.map = map;
  this.canEdit = canEdit;
  this.$element = angular.element(document.getElementById('map'));

  this.map.on('pointermove', this.handlePointerMove.bind(this));
  this.map.on('click', this.handleClick.bind(this));
  this.$element.on('mouseup', this.handleMouseUp.bind(this));
}

MouseCursor.prototype.handlePointerMove = function(event) {
  var cursor =
    this.zoomIn(event) && 'zoom-in' ||
    this.grabbing(event) && 'grabbing' ||
    this.pointer(event) && 'pointer';

  this.updateCursor(cursor || '');
};

MouseCursor.prototype.handleClick = function() {
  this.updateCursor('');
};

MouseCursor.prototype.handleMouseUp = function() {
  if (this.cursor === 'zoom-in' || this.cursor === 'grabbing') {
    this.updateCursor('');
  }
};

MouseCursor.prototype.updateCursor = function(cursor) {
  if (cursor !== this.cursor) {
    this.cursor = cursor;
    this.$element.removeClass('zoom-in grabbing pointer');
    cursor && this.$element.addClass(cursor);
  }
};

MouseCursor.prototype.zoomIn = function(event) {
  return event.dragging &&
    (this.cursor === 'zoom-in' || ol.events.condition.shiftKeyOnly(event));
};

MouseCursor.prototype.grabbing = function(event) {
  return event.dragging && ol.events.condition.noModifierKeys(event);
};

MouseCursor.prototype.pointer = function(event) {
  if (! this.canEdit) return false;

  return this.map.forEachFeatureAtPixel(event.pixel, function(feature) {
    return ! feature.get('pickupLocation');
  });
};

module.exports = MouseCursor;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/lib/map/mouseCursor.js
 ** module id = 184
 ** module chunks = 1
 **/